<template>
  <div class="row pr-4">
    <div class="col-12">
      <PageTitle title="Meus sorteio" />
    </div>

    <div class="col-12 text-right mb-2">
      <button class="btn btn-primary" @click="novoSorteio()" v-if="whatClerkPermission()">
        <i class="fas fa-plus"></i>
        Adicionar novo sorteio
      </button>
    </div>

    <div class="col-12 mt-2" v-for="(sorteio, i) in sorteios" :key="i">

      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle="'accordion-' + i" :variant="sorteio.status == true ? 'success' : 'danger'">
              Sorteio: <b>{{sorteio.name}}</b> - 
              Início: <b>{{formatarData(sorteio.campaign_start)}}</b> -
              Fim: <b>{{formatarData(sorteio.campaign_end)}}</b>
            </b-button>
          </b-card-header>
          <b-collapse :id="'accordion-' + i" accordion="my-accordion" role="tabpanel">
            <b-card-body>

              <div class="row">
                <div class="col-12 text-center">
                  <h4 class="text-uppercase c-orange font-weight-bold d-inline">
                    DADOS DO SORTEIO
                  </h4>
                </div>

                <div class="col-3 mb-2">
                  <button class="btn btn-primary mr-1" @click="buscarcupons(sorteio.id)" v-if="whatClerkPermission()">
                    <i class="fas fa-users"></i>
                    Realizar sorteio
                  </button>
                </div>

                <div class="col-9 text-right mb-2">
                  <button class="btn btn-primary mr-1" @click="getCupomPoints(sorteio.id)">
                    <i class="fas fa-search"></i>
                    Buscar cupom gerado
                  </button>

                  <button class="btn btn-dark mr-1" @click="getQrCodePoints(sorteio.id)">
                    <i class="fas fa-eye"></i>
                    Ver qr-code gerado
                  </button>

                  <button class="btn btn-info mr-1" @click="qrCodePoints(sorteio)" v-if="whatClerkPermission()">
                    <i class="fas fa-qrcode"></i>
                    Gerar cupom com o qr-code
                  </button>

                  <button class="btn btn-success mr-1" @click="updateRaffle(sorteio)" v-if="whatClerkPermission()">
                    <i class="fas fa-edit"></i>
                    Editar dados do sorteio
                  </button>
                </div>

                <div class="col-4 mb-2">
                  <label>Nome do sorteio:</label>
                  <input type="text" class="form-control" :value="sorteio.name" readonly>
                </div>

                <div class="col-8 mb-2">
                  <label>Descrição do sorteio:</label>
                  <input type="text" class="form-control" :value="sorteio.description" readonly>
                </div>

                <div class="col-3">
                  <label>Início do sorteio:</label>
                  <input type="text" class="form-control" :value="formatarData(sorteio.campaign_start)" readonly>
                </div>

                <div class="col-3">
                  <label>Fim do sorteio:</label>
                  <input type="text" class="form-control" :value="formatarData(sorteio.campaign_end)" readonly>
                </div>

                <div class="col-3">
                  <label>Valor do sorteio:</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="'A cada '+formatarValor(sorteio.price)+' você ganha '+sorteio.points+ ' cupons'" 
                    readonly
                  >
                </div>

                <div class="col-3">
                  <label>Status:</label>
                  <span 
                    class="cursor-pointer float-right" 
                    v-b-tooltip.hover :title="sorteio.status == true ? 'Inativar' : 'Ativar'"
                    @click="updateStatusRaffle(sorteio.id)"
                    v-if="whatClerkPermission()"
                  >
                    <i class="fas fa-sync"></i>
                  </span>
                  <button :class="sorteio.status == true ? 'statusAtivoBtn' : 'statusInativoBtn'">
                    {{ sorteio.status == true ? 'Ativo' : 'Inativo' }}
                  </button>
                </div>
                
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>

    <b-modal
      :title="this.sorteio.id == null ? 'Novo sorteio' : 'Atualizar sorteio'"
      size="xl"
      id="modal-meus-sorteios"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-4">
          <label>Nome do sorteio</label>
          <input type="text" v-model="sorteio.name" class="form-control" placeholder="Nome do sorteio" maxlength="255">
        </div>

        <div class="col-8">
          <label>Descrição</label>
          <input type="text" v-model="sorteio.description" class="form-control" placeholder="Descrição do sorteio" maxlength="255">
        </div>

        <div class="col-3 mt-2">
          <label>Início do sorteio</label>
          <input type="date" v-model="sorteio.campaign_start" class="form-control">
        </div>

        <div class="col-3 mt-2">
          <label>Fim do sorteio</label>
          <input type="date" v-model="sorteio.campaign_end" class="form-control">
        </div>

        <div class="col-3 mt-2">
          <label>Gastando XX (R$)</label>
          <input type="text" v-model="sorteio.price" class="form-control" v-money="money" @change="formatOrder('price')">
        </div>

        <div class="col-3 mt-2">
          <label>Você ganha XX cupom</label>
          <input type="text" v-model="sorteio.points" class="form-control" placeholder="XX" @change="formatOrder()">
        </div>

        <div class="col-12 text-center mt-4">
          <button class="btn btn-success btn-block" @click="sendFormSorteio()">
            {{ this.sorteio.id == null ? 'Criar sorteio' : 'Atualizar sorteio' }}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Gerar qr-code para pontos do sorteio"
      size="lg"
      id="modal-qr-code-sorteio-points"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-6">
          <label>Valor da compra</label>
          <input 
            type="text"
            v-model="cupom.valorPontos"
            v-money="money"
            class="form-control"
            :disabled="cupom.sorteioDiario == true"
          >
        </div>

        <div class="col-6">
          <label>Qtd. de cupons para esse qr-code</label>
          <input 
            type="integer"
            v-model="cupom.sorteioPontos"
            class="form-control"
            placeholder="xx"
            disabled
          >
        </div>

        <div class="col-12 mt-2">
          <label>Qr-code diário?</label><br>
          <input 
            type="checkbox" 
            v-model="cupom.sorteioDiario"
            style="width: 30px; height:30px"
            @click="formatValue()"
          >
        </div>

        <div class="col-12" v-if="cupom.sorteioQrCode != null">
          <div class="text-center mt-4">
            <span class="d-none">
              <qrcode-vue
                class="mt-2"
                :value="cupom.sorteioQrCode"
                size=500
                level="H"
                id="qrCodeCanvasPontos"
              />
            </span>
            <qrcode-vue
              class="mt-2"
              :value="cupom.sorteioQrCode"
              size=350
              level="H"
              id="qrCodeCanvasPontos"
            />
            <button 
              @click="downloadQrCode('qrCodeCanvasPontos', 'qrcode_pontos.png')" 
              size="sm" 
              class="btn btn-outline-success btn-sm"
            >
              <i class="fas fa-download mr-2"></i>
              Baixar qr code
            </button>
          </div>
        </div>

        <div class="col-12 text-center mt-4">
          <button class="btn btn-success btn-block" @click="generateQrCode()">
            Gerar qr-code
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Nome do ganhador"
      size="md"
      id="modal-nome-ganhador"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12 mb-2">
          <label>Nome do ganhador</label>
          <input 
            type="text"
            class="form-control"
            :value="nome"
            disabled
          >
        </div>

        <div class="col-6">
          <label>Documento do ganhador</label>
          <input 
            type="text"
            class="form-control"
            :value="documentoMostrar == true ? documento : '***************'"
            disabled
          >
        </div>

        <div class="col-6 d-flex flex-column">
          <div class="flex-grow-1"></div>
          <button 
            @click="documentoMostrar = !documentoMostrar"
            :class="documentoMostrar == true ? 'btn btn-danger btn-block' : 'btn btn-primary btn-block'"
          >
            {{documentoMostrar == true ? 'Esconder documento' : 'Mostrar documento'}}
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Cupons disponível para sorteio"
      size="xl"
      id="modal-show-coupons"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <span
            v-for="(item, i) in cupons"
            :key="i"
            :class="{
              highlight: highlightedIndex === i && !isStopped,
              finalHighlight: highlightedIndex === i && isStopped
            }"
            class="couponList"
          >
            {{ item.coupon }}
          </span>
        </div>
        <div class="col-6 mt-2" v-if="ganhador == null">
          <button 
            class="btn btn-success btn-block"
            @click="startHighlight()"
          >
            Iniciar sorteio
          </button>
        </div>

        <div class="col-6 mt-2" v-if="ganhador == null">
          <button 
            class="btn btn-primary btn-block"
            @click="exportCsv()"
          >
            Exportar CSV dos cupons
          </button>
        </div>
        
        <div class="col-12 mt-2" v-if="ganhador != null">
          <button 
            class="btn btn-primary btn-block"
            @click="verGanhador()"
          >
            Ver nome do ganhador
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Qr-code já gerados para o sorteio"
      size="xl"
      id="modal-show-qr-code-coupons"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-12">
          <table class="table table-stripe table-bordered">
            <thead>
              <tr>
                <th>Cliente</th>
                <th class="text-center">Valor</th>
                <th class="text-center">Qtd. cupom</th>
                <th>Criado em</th>
                <th>Resgatado em</th>
                <th class="text-center">Status</th>
                <th class="text-center">Colaborador</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in qrcodeGerados" :key="i">
                <td>
                  <span v-if="item.user && item.user.client">
                    {{item.user.client.first_name}} {{item.user.client.last_name}}
                  </span>
                  <span v-else-if="item.user && item.user.company">
                    {{item.user.company.nome_fantasia}}
                  </span>
                  <span v-else-if="item.user && item.user.professional">
                    {{item.user.professional.name}}
                  </span>
                </td>
                <td class="text-center">{{formatarValor(item.money)}}</td>
                <td class="text-center">{{item.qtd}}</td>
                <td>{{item.created_at}}</td>
                <td>{{item.date_accepted}}</td>
                <td class="text-center">
                  <b-badge v-if="item.status == 1" variant="success">Resgatado</b-badge>
                  <b-badge v-else variant="danger">Não Resgatado</b-badge>
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-dark btn-sm"
                    v-if="item.colaborador_id != null"
                    @click="getColaborador(item.colaborador_id)"
                  >
                    <i class="fas fa-eye"></i>
                  </button>

                  <span v-if="item.colaborador_id == null">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Cupons gerados para o sorteio"
      size="xl"
      id="modal-show-coupons-valid"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-6">
          <label>Data início</label>
          <input type="date" v-model="dateInit" class="form-control">
        </div>

        <div class="col-6">
          <label>Data fim</label>
          <input type="date" v-model="dateEnd" class="form-control">
        </div>

        <div class="col-12 text-center mt-2 mb-4">
          <button class="btn btn-success" @click="buscarCuponsSorteio()">
            Buscar
          </button>
        </div>

        <div class="col-12 text-center" v-if="cuponsGerados.length > 0">
          <table class="table table-stripe table-bordered">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>CPF / CNPJ</th>
                <th>Fone</th>
                <th>Cupom</th>
                <th>Criado em</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in cuponsGerados" :key="i">
                <td>
                  <span>
                    {{item.user.name}}
                  </span>
                </td>
                <td>{{item.user.document}}</td>
                <td>{{item.user.phone}}</td>
                <td>{{item.coupon}}</td>
                <td>{{item.created_at}}</td>
              </tr>
            </tbody>
          </table>

          <button class="btn btn-primary" @click="generateCouponsBatch()" v-if="userTypeId() == 4402 || userTypeId() == 3848">
            Gerar cupons
          </button>
        </div>
        <div class="col-12" v-else>
          <b-alert show variant="warning">Nenhum resultado disponível</b-alert>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import QrcodeVue from 'qrcode.vue';
import UserTypes from '@/enums/UserTypes';
import NamePermission from '@/enums/Clerk/NamePermission';
import TypePermission from '@/enums/Clerk/TypePermission';

export default {
  name: 'LojistaMinhasRegras',
  mixins: [makeToast],
  components: {
    PageTitle,
    QrcodeVue
  },

  data() {
    return {
      dados: [],
      dateInit: '',
      dateEnd: '',
      sorteios: [],
      cupons: [],
      qrcodeGerados: [],
      cuponsGerados: [],
      sorteioSelecionado: null,
      sorteioId: null,
      cupom: {
        valorPontos: '',
        sorteioPontos: null,
        sorteioQrCode: null,
        qrCodeDiario: null,
        sorteioDiario: false

      },
      sorteio: {
        id: null,
        name: '',
        description: '',
        price: null,
        points: null,
        campaign_start: null,
        campaign_end: null,
        construp_user_id: null,
        status: false
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      nome: '',
      documento: '',
      documentoMostrar: false,
      highlightedIndex: -1,
      intervalId: null,
      timeoutId: null,
      ganhador: null,
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  watch: {
    'cupom.valorPontos' : function(){
      if(this.cupom.valorPontos.match(/-/)) {
        this.cupom.valorPontos = 'R$ 0,00';
        this.makeToast('Erro', 'Os valor não pode ser negativo!', 'danger');
      } else {
        if(this.cupom.valorPontos && this.cupom.valorPontos != '' && this.cupom.valorPontos != 'R$ 0,00') {
          const valorNumerico = this.cupom.valorPontos.replace('R$', '').replace('.', '').replace(',', '.').trim();
          const valor = parseFloat(valorNumerico);

          const qtd = valor / parseFloat(this.sorteioSelecionado.price);
          const qtdFormat = Math.floor(qtd);

          this.cupom.sorteioPontos = qtdFormat * this.sorteioSelecionado.points;
        }
      }
    }
  },

  created() {
    this.get();

    this.qrCodeDiario = this.userTypeId();
  },

  methods: {
    generateCouponsBatch() {
      const numCoupons = this.cuponsGerados.length;
      const couponsPerPage = 10;
      const numPages = Math.ceil(numCoupons / couponsPerPage);

      const a4Width = 794;
      const a4Height = 1123;

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = a4Width;
      canvas.height = a4Height * numPages;

      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = 'https://construp-imagens.s3.us-east-2.amazonaws.com/logos/cupom.png';

      img.onload = () => {
        const couponWidth = img.width;
        const couponHeight = img.height;

        const scaleFactorX = (a4Width - 10) / (couponWidth * 2);
        const scaleFactorY = (a4Height - 25) / (couponHeight * 5);
        const scaleFactor = Math.min(scaleFactorX, scaleFactorY);

        const scaledCouponWidth = couponWidth * scaleFactor;
        const scaledCouponHeight = couponHeight * scaleFactor;

        const marginX = 5;
        const marginY = 5;

        for (let i = 0; i < numCoupons; i++) {
          const pageIndex = Math.floor(i / couponsPerPage);
          const couponIndexOnPage = i % couponsPerPage;

          const row = Math.floor(couponIndexOnPage / 2);
          const col = couponIndexOnPage % 2;

          const x = marginX + col * (scaledCouponWidth + marginX);
          const y = marginY + row * (scaledCouponHeight + marginY) + pageIndex * a4Height;

          if (couponIndexOnPage === 0) {
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, pageIndex * a4Height, a4Width, a4Height);
          }

          const data = this.cuponsGerados[i];
          ctx.drawImage(img, x, y, scaledCouponWidth, scaledCouponHeight);
          ctx.font = `${30 * scaleFactor}px Arial`;
          ctx.fillStyle = '#000';

          ctx.fillText(data.user.name, x + 465 * scaleFactor, y + 455 * scaleFactor);
          ctx.fillText(data.user.document, x + 485 * scaleFactor, y + 505 * scaleFactor);
          ctx.fillText(data.user.city, x + 980 * scaleFactor, y + 505 * scaleFactor);
          ctx.fillText(data.user.phone, x + 540 * scaleFactor, y + 560 * scaleFactor);

          ctx.strokeStyle = '#000';
          ctx.lineWidth = 1;
          ctx.strokeRect(x, y, scaledCouponWidth, scaledCouponHeight);
        }

        for (let page = 0; page < numPages; page++) {
          const pageCanvas = document.createElement('canvas');
          pageCanvas.width = a4Width;
          pageCanvas.height = a4Height;
          const pageCtx = pageCanvas.getContext('2d');

          pageCtx.drawImage(canvas, 0, -page * a4Height);

          const pageImage = pageCanvas.toDataURL('image/png');
          this.downloadImage(pageImage, `page-${page + 1}.png`);
        }
      };
    },
    downloadImage(dataUrl, filename) {
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    startHighlight() {
      if (this.intervalId) clearInterval(this.intervalId);
      if (this.timeoutId) clearTimeout(this.timeoutId);

      this.isStopped = false;

      this.intervalId = setInterval(() => {
        this.highlightedIndex = Math.floor(Math.random() * this.cupons.length);
      }, 400);

      const randomTime = Math.random() * 10000 + 7000;
      this.timeoutId = setTimeout(() => {
        clearInterval(this.intervalId);
        this.highlightedIndex = Math.floor(Math.random() * this.cupons.length);
        this.isStopped = true;

        this.ganhador = this.cupons[this.highlightedIndex].coupon;
      }, randomTime);
    },
    formatValue(){
      this.cupom.sorteioPontos = null;
      this.cupom.valorPontos = '';
      if(this.cupom.sorteioDiario == false) {
        this.cupom.sorteioPontos = 1
      }
    },
    verGanhador() {
      const data = {
        ganhador: this.ganhador,
        sorteioId: this.sorteioId
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/nomeGanhador', data)
        .then((response) => {
          if(response.data.nome) {
            this.nome = response.data.nome;
            this.documento = response.data.documento;

            this.$bvModal.show('modal-nome-ganhador');
          } else {
            this.makeToast('Opss', 'Houve um erro ao buscar o nome do ganhador!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar o nome do ganhador!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    get() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getRaffleCampaign', this.userTypeId())
        .then((response) => {
          if(response.data.length > 0) {
            this.sorteios = response.data;
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar seus sorteio(s)!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    sendFormSorteio() {
      var valid = this.validarFormSorteio();

      if(valid == true) {
        this.sorteio.construp_user_id = this.userTypeId();

        this.$store.dispatch('startLoader');
        this.$store.dispatch('shopkeeper/saveRaffleCampaign', this.sorteio)
          .then((response) => {
            if(response.data.error == false) {
              this.$bvModal.hide('modal-meus-sorteios');
              this.makeToast('Sucesso', response.data.message, 'success');
              this.get();
            } else {
              this.makeToast('Opss', response.data.message, 'danger');
              this.$store.dispatch('endLoader');
            }
          })
          .catch(() => {
            this.makeToast('Opss', 'Houve um erro ao enviar dados do seu sorteio!', 'danger');
            this.$store.dispatch('endLoader');
          });
      }
    },
    updateStatusRaffle(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/updateStatusRaffle', id)
        .then((response) => {
          if(response.data.error == false) {
            this.makeToast('Sucesso', response.data.message, 'success');
            this.get();
          } else {
            this.makeToast('Opss', response.data.message, 'danger');
            this.$store.dispatch('endLoader');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao atualizar o status!', 'danger');
          this.$store.dispatch('endLoader');
        });
    },
    getColaborador(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getColaborador', id)
        .then((response) => {
          if(response.data.name) {
            const msg = 'Nome:'+response.data.name+' - Fone:'+response.data.phone +' - Cpf:'+response.data.cpf;
            this.makeToast('Sucesso', msg, 'primary');
          } else {
            this.makeToast('Opss', 'Erro ao buscar o colaborador', 'danger');
          }
          this.$store.dispatch('endLoader');
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar o colaborador!', 'danger');
          this.$store.dispatch('endLoader');
        });
    },
    buscarcupons(id) {
      this.ganhador = null;
      this.sorteioId = id;

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getCouponsId', id)
        .then((response) => {
          if(response.data.length && response.data.length > 0) {
            this.cupons = response.data;
            this.$bvModal.show('modal-show-coupons');
          } else {
            this.makeToast('Opss', 'Esse sorteio ainda não tem cupom!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar os cupons!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    limparCampos() {
      this.cupom.valorPontos = '';
      this.cupom.sorteioPontos = null;
      this.cupom.sorteioQrCode = null;
      this.cupom.qrCodeDiario = null;
      this.cupom.sorteioDiario = false;

    },
    qrCodePoints(sorteio) {
      this.limparCampos();

      this.sorteioId = sorteio.id;
      this.sorteioSelecionado = sorteio;
      this.$bvModal.show('modal-qr-code-sorteio-points');
    },
    getCupomPoints(id) {
      this.sorteioId = id;
      this.cuponsGerados = [];

      this.$bvModal.show('modal-show-coupons-valid');
    },
    buscarCuponsSorteio() {
      const data = {
        dateStart: this.dateInit,
        dateEnd: this.dateEnd,
        sorteioId: this.sorteioId
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/buscarCuponsSorteio', data)
        .then((response) => {
          if(response.data.length && response.data.length > 0) {
            this.cuponsGerados = response.data;
          } else {
            this.makeToast('Opss', 'Esse sorteio ainda não tem cupom!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar os cupons!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    getQrCodePoints(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getQrCodePoints', id)
        .then((response) => {
          if(response.data.length && response.data.length > 0) {
            this.qrcodeGerados = response.data;
            this.$bvModal.show('modal-show-qr-code-coupons');
          } else {
            this.makeToast('Opss', 'Esse sorteio ainda não tem cupom!', 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Opss', 'Houve um erro ao buscar os cupons!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    generateQrCode() {
      if(this.cupom.sorteioDiario == true) {
        this.cupom.sorteioQrCode = btoa(this.sorteioId+'##*##'+this.cupom.sorteioPontos+'##*##'+this.cupom.sorteioDiario);
        return;
      }

      const colaboradorId = this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.id : null;

      const data = {
        userId: this.userTypeId(),
        campaignId: this.sorteioId,
        colaborador_id: colaboradorId,
        cupom: this.cupom
      }

      this.$store.dispatch('startLoader');
        this.$store.dispatch('shopkeeper/newRaffleCampaignCouponQtd', data)
          .then((response) => {
            if(response.data.id) {
              this.cupom.sorteioQrCode = 
              btoa(this.sorteioId+'##*##'+this.cupom.sorteioPontos+'##*##'+this.cupom.sorteioDiario+'##*##'+response.data.id);
            } else {
              this.makeToast('Opss', 'Erro ao gerar qr-code!', 'danger');
            }
          })
          .catch(() => {
            this.makeToast('Opss', 'Erro ao gerar qr-code!', 'danger');
          }).finally(() => {
            this.$store.dispatch('endLoader');
          })
    },
    downloadQrCode(elementId, fileName){
      var qrCodeCanvas = document.getElementById(elementId).getElementsByTagName('canvas');
      var dataUrl = qrCodeCanvas[0].toDataURL();

      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      };

      xhr.open('GET', dataUrl);
      xhr.send();
    },
    exportCsv() {
      const rows = this.cupons.map((item) => {
        return [
          `"${item.coupon || ''}"`
        ].join(',');
      });

      const csvData = [
        'cupom',
        ...rows,
      ].join('\n');

      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'cupons_sorteio.csv';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    updateRaffle(sorteio) {
      this.sorteio = sorteio;
      this.$bvModal.show('modal-meus-sorteios');
    },
    novoSorteio() {
      this.limparCamposSorteio();
      this.$bvModal.show('modal-meus-sorteios');
    },
    validarFormSorteio() {
      var valid = true;

      if(this.sorteio.name == '') {
        this.makeToast('Opss', 'Informe o nome do sorteio!', 'danger');
        valid = false;
      }

      if(this.sorteio.description == '') {
        this.makeToast('Opss', 'Informe a descrição do sorteio!', 'danger');
        valid = false;
      }

      if(this.sorteio.price == null || this.sorteio.price == '' || this.sorteio.price == 'R$ 0,00') {
        this.makeToast('Opss', 'Informe o valor para ganhar os pontos do sorteio!', 'danger');
        valid = false;
      }

      if(this.sorteio.points == null || this.sorteio.points == '') {
        this.makeToast('Opss', 'Informe os pontos do sorteio!', 'danger');
        valid = false;
      }

      if(this.sorteio.campaign_start == null || this.sorteio.campaign_start == '') {
        this.makeToast('Opss', 'Informe a data do início do sorteio!', 'danger');
        valid = false;
      }

      if(this.sorteio.campaign_end == null || this.sorteio.campaign_end == '') {
        this.makeToast('Opss', 'Informe a data do fim do sorteio!', 'danger');
        valid = false;
      }

      if(this.sorteio.campaign_start > this.sorteio.campaign_end) {
        this.makeToast('Opss', 'A data do início do sorteio não pode ser maior do que data de fim!', 'danger');
        valid = false;
      }

      return valid;
    },
    formatOrder(type = 'points') {
      if(type == 'points') {
        if(this.sorteio.points.match(/-/)) {
          this.sorteio.points = null;
          this.makeToast('Erro', 'Os cupons não pode ser negativo!', 'danger');
        }
      } else {
        if(this.sorteio.price.match(/-/)) {
          this.sorteio.price = '';
          this.makeToast('Erro', 'O valor não pode ser negativo!', 'danger');
        }
      }
    },
    formatarValor(valor) {
      let formatador = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      });

      return formatador.format(valor);
    },
    limparCamposSorteio() {
      this.sorteio.id = null;
      this.sorteio.name = '';
      this.sorteio.description = '';
      this.sorteio.price = null;
      this.sorteio.points = null;
      this.sorteio.campaign_start = null;
      this.sorteio.campaign_end = null;
      this.sorteio.construp_user_id = null;
      this.sorteio.status = false;
    },
    formatarData(dataHoraOriginal) {
      let [ano, mes, dia] = dataHoraOriginal.split('-');

      let dataHora = new Date(Date.UTC(ano, mes - 1, dia));
      dataHora.setUTCDate(dataHora.getUTCDate() + 1);

      let opcoesFormato = { day: '2-digit', month: '2-digit', year: 'numeric' };
      let dataHoraFormatada = new Intl.DateTimeFormat('pt-BR', opcoesFormato).format(dataHora);

      return dataHoraFormatada;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.SORTEIO);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    },
  }
}
</script>

<style scoped>
.statusAtivo {
  background: #3bb53b;
  color: #FFF;
  padding: 0 10px;
  border-radius: 4px;
}
.statusInativo {
  background: #e71a1a;
  color: #FFF;
  border-radius: 4px;
}
.statusAtivoBtn {
  background: #3bb53b;
  color: #FFF;
  width: 100%;
  height: 37px;
  border: none;
  border-radius: 4px;
}
.statusInativoBtn {
  background: #e71a1a;
  color: #FFF;
  width: 100%;
  height: 37px;
  border: none;
  border-radius: 4px;
}
.couponList {
  line-height: 2.2;
  margin-right: 5px;
  border: 2px solid #222;
  border-radius: 4px;
  padding: 2px 5px;
  color: #004085;
  border-color: #b8daff;
  background-color: #cce5ff;
  transition: background-color 0.3s;
}
.highlight {
  background-color: yellow;
}
.finalHighlight {
  cursor: pointer;
  color: #fff;
  background-color: #3f3f3f;
  border-color: #000;
}
input {
  display: block;
  margin-bottom: 10px;
}
canvas {
  display: none;
}
</style>